import last from "lodash/last";
import pull from "lodash/pull";
import find from "lodash/find";
import {
  ADD_FIELD,
  REMOVE_FIELD,
  UPDATE_FIELD,
  UPDATE_LAYER,
  RECEIVE_BERT_WAREHOUSE_CONFIGURATION,
  UPDATE_GLOBAL_PARAMETER,
} from "./Actions";

const initialState = {
  height: "frontend_heightBERT2000",
  depth: "frontend_depth300",
  doubleShelf: false,
  color: "galvanized",
  usableFromBothSides: false,
  overallWidth: 2066,
  shelfLoad: "frontend_shelfLoad150",
  scaleFactor: 0,
  fields: [
    {
      id: 1,
      width: "frontend_width1005",
      layers: "frontend_layers5",
      rightPanel: false,
      leftPanel: false,
      floor: "steel",
    },
    {
      id: 2,
      width: "frontend_width1005",
      layers: "frontend_layers5",
      rightPanel: false,
      leftPanel: false,
      floor: "steel",
    },
  ],
};

export default function BertWarehouseReducer(state = initialState, action = {}) {
  switch (action.type) {
    case ADD_FIELD: {
      const fields = state.fields;
      // the new field is always a copy of the last field
      const lastField = last(fields);
      const newField = {
        ...lastField,
        id: lastField.id + 1,
        leftPanel: lastField.rightPanel,
      };
      fields.push(newField);
      return {
        ...state,
        fields,
      };
    }

    case REMOVE_FIELD: {
      const { fieldId } = action;
      const fields = state.fields;
      const fieldToRemove = find(fields, { id: fieldId });
      const newFields = pull(fields, fieldToRemove);
      const newFieldsLength = newFields.length;
      newFields.map((field) => {
        if (field.id > fieldId) {
          field.id -= 1;
        }
        if (fieldId === newFieldsLength) {
          field.isRightOuterField = true;
        }
      });

      return {
        ...state,
        fields: newFields,
      };
    }

    case UPDATE_FIELD: {
      const { fieldId, key, value } = action;
      const newFields = state.fields;
      find(newFields, { id: fieldId })[key] = value;
      if (key === "leftPanel") {
        const prevFieldId = fieldId === 1 ? null : fieldId - 1;
        if (prevFieldId) {
          find(newFields, { id: prevFieldId })["rightPanel"] = value;
        }
      } else if (key === "rightPanel") {
        const nextFieldId = fieldId === newFields.length ? null : fieldId + 1;
        if (nextFieldId) {
          find(newFields, { id: nextFieldId })["leftPanel"] = value;
        }
      }
      return {
        ...state,
        fields: newFields,
      };
    }

    case UPDATE_LAYER: {
      const { fieldId, layerId, key, value } = action;
      const newFields = state.fields;
      const field = find(newFields, { id: fieldId });
      find(field.layers, { id: layerId })[key] = value;
      return {
        ...state,
        fields: newFields,
      };
    }

    case UPDATE_GLOBAL_PARAMETER: {
      const { key, value } = action;
      const newFields = state.fields;
      if (key === "floor") {
        newFields.forEach((field) => {
          field.layers.forEach((layer) => (layer.floor = value));
        });
      }
      const newState = {
        ...state,
        doubleShelf: key === "doubleShelf" ? value : state.doubleShelf,
        height: key === "height" ? value : state.height,
        depth: key === "depth" ? value : state.depth,
        color: key === "color" ? value : state.color,
        usableFromBothSides: key === "usableFromBothSides" ? value : state.usableFromBothSides,
        shelfLoad: key === "shelfLoad" ? value : state.shelfLoad,
        overallWidth: key === "overallWidth" ? value : state.overallWidth,
        scaleFactor: key === "scaleFactor" ? value : state.scaleFactor,
        fields: newFields,
      };
      return newState;
    }

    case RECEIVE_BERT_WAREHOUSE_CONFIGURATION: {
      const { data } = action;
      const newState = data;
      return newState;
    }

    default:
      return state;
  }
}
